import { onDeleteError, onFormError, onActionError } from '../../core/utils/hooks'
import { notification } from 'antd'

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  load,
  loadDto,
  create,
  update,
  vendorList,

  createQA,
  updateQA,
  removeQA,

  createQAComment,
  removeQAComment,

  createQAScorecard,
  downloadQAScorecard,
  removeQAScorecard,

  postBitacoraMessage,

  updateStatus,
  updatePrices,
  clientConfirmation,
  satisfactionStatus,
  createStorage,

  createTask,
  updateTask,
  updateTaskStatus,
  removeTask,
  updateTaskVendorModal,




  fetchWithPagination,
  toggle,
  remove

} from '../../api/manager/job'



const key = 'manager.job'
const keyAssign = 'manager.job.assign'
const keyShow = 'manager.job.show'

export const useList = (queryParams) => {
  return useQuery({
    queryKey: [key, queryParams],
    queryFn: () => fetchWithPagination(queryParams)
  })
}

export const useFetchDto = (id) => {
  return useQuery({
    queryKey: [keyShow, id],
    queryFn: () => loadDto(id)
  })
}

export const useFetch = (id) => {
  return useQuery({
    queryKey: [key, id],
    queryFn: () => load(id)
  })
}

export const usePostForm = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: create,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Created',
        description: 'The Job was created'
      })
    },
    onError: onFormError
  })
}

export const usePutForm = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => update(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key, id])

      notification.success({
        message: 'Updated',
        description: 'The Job was updated'
      })
    },
    onError: onFormError
  })
}

export const useVendorList = (id, taskId) => {
  return useQuery({
    queryKey: [keyAssign, id, taskId],
    queryFn: () => vendorList(id, taskId)
  })
}

export const useCreateTask = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => createTask(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Created',
        description: 'The task was created'
      })
    },
    onError: onFormError
  })
}

export const useUpdateTask = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => updateTask(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Update',
        description: 'The Task was updated'
      })
    },
    onError: onFormError
  })
}

/**
 * LQA
 */

export const useQACreate = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => createQA(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Created',
        description: 'The QA was created'
      })
    },
    onError: onFormError
  })
}

export const useQAUpdate = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => updateQA(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The QA was updated'
      })
    },
    onError: onFormError
  })
}

export const useQARemove = (id) => {
  const queryClient = useQueryClient()
  const action = (qaId) => removeQA(id, qaId)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Deleted',
        description: 'The QA was deleted'
      })
    },
    onError: onDeleteError
  })
}

export const useQACreateComment = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => createQAComment(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Created',
        description: 'The comment was added'
      })
    },
    onError: onFormError
  })
}

export const useQARemoveComment = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => removeQAComment(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Deleted',
        description: 'The QA was deleted'
      })
    },
    onError: onDeleteError
  })
}

export const useQAUploadScorecard = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => createQAScorecard(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Created',
        description: 'The scorecard was added'
      })
    },
    onError: onFormError
  })
}

export const useQADownloadScorecard = (id) => {
  const action = (qaId) => downloadQAScorecard(id, qaId)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {

    },
    onError: onActionError
  })
}

export const useQARemoveScorecard = (id) => {
  const queryClient = useQueryClient()
  const action = (qaId) => removeQAScorecard(id, qaId)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Deleted',
        description: 'The QA was deleted'
      })
    },
    onError: onDeleteError
  })
}

export const useBitacoraMessage = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => postBitacoraMessage(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Created',
        description: 'The comment was added'
      })
    },
    onError: onFormError
  })
}

export const useUpdateStatus = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => updateStatus(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The Job was updated'
      })
    },
    onError: onFormError
  })
}

export const useUpdatePrices = (id) => {
  const queryClient = useQueryClient()
  const action = () => updatePrices(id)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Update',
        description: 'The Job was updated.'
      })
    },
    onError: onFormError
  })
}

export const useClientConfirmation = (id) => {
  const queryClient = useQueryClient()
  const action = () => clientConfirmation(id)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Update',
        description: 'The Job was updated.'
      })
    },
    onError: onFormError
  })
}

export const useCreateStorage = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => createStorage(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])
    },
    onError: onFormError
  })
}

export const useUpdateTaskStatus = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => updateTaskStatus(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])
    },
    onError: onFormError
  })
}

export const useUpdateTaskVendorModal = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => updateTaskVendorModal(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])
    },
    onError: onFormError
  })
}

export const useRemoveTask = (id) => {
  const queryClient = useQueryClient()
  const action = (taskId) => removeTask(id, taskId)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Deleted',
        description: 'The Task was deleted'
      })
    },
    onError: onDeleteError
  })
}


export const useSatisfactionStatus = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => satisfactionStatus(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Update',
        description: 'The Job was updated.'
      })
    },
    onError: onFormError
  })
}










export const useToggle = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: toggle,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The client was updated'
      })
    },
    onError: onActionError
  })
}

export const useRemove = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: remove,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Deleted',
        description: 'The client was deleted'
      })
    },
    onError: onDeleteError
  })
}


